import React, { Fragment } from "react";
import { withTranslation } from "react-i18next";
import { Drawer, notification, Modal, Button } from "antd";
import { ExclamationCircleOutlined } from "@ant-design/icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQuestionCircle } from "@fortawesome/pro-solid-svg-icons";
import { faBadgeCheck } from "@fortawesome/pro-duotone-svg-icons";

import {
    isObjectNotEmpty,
    isStringEmpty,
    parseBoolOr,
    parseJsonOr,
    parseStringOr,
} from "../helpers/AppxUtils";

import TvServiceInfo from "../components/TvServiceInfo";
import TvDrawer from "../components/TvDrawer";
import TvPlanFooter from "../components/TvPlanFooter";
import TvReview from "../components/TvReview";
import TvFavPackRemoveDialog from "../components/TvFavPackRemoveDialog";
import TvPlanSteps from "../components/TvPlanSteps";
import TvPlanStep from "../components/TvPlanStep";
import TvPlanStarter from "../components/TvPlanStarter";
import TvPlanFavList from "../components/TvPlanFavList";
import TvPickList from "../components/TvPickList";
import TvPickMoviePack from "../components/TvPickMoviePack";
import TvPickGroupPack from "../components/TvPickGroupPack";
import Tip from "../components/Tip";

import defaultPlans from "../default-plans.js";
import helpImgEn from "../tile-des1-en.gif";
import helpImgFr from "../tile-des1-fr.gif";
import helpImgEnPickMode from "../tile-des1-en-pick-mode.gif";
import helpImgFrPickMode from "../tile-des1-fr-pick-mode.gif";

const TvPlanContext = React.createContext();
const TvPlanContextConsumer = TvPlanContext.Consumer;


class TvPlanContextProviderCom extends React.Component {
    tvConfig = {};
    tvPlan = null;
    tvPlanId = 0;
    pickMode = null;
    state = {
        loading: true,
        showInfoVisible: false,
        selection: {
            service: {},
            fav: {},
            pickGroup: {},
            implicit: {},
        },
        priceChoice: {},
        servicePrice: {},
        pickCount: 0,
        pickMoreForDiscountCount: 0,
        groupCount: 0,
        price: 0,
        priceAt: 0,
        showGroupTip: false,
        checklist: [],
        mustUpdate: 0,
    };

    constructor(props) {
        super(props);

        this.app = props.theme.app || "";

        if (this.app === "") {
            throw new Error('App is mandatory!');
        }

        this.org = props.theme.org || "";

        if (this.org === "") {
            throw new Error('Org is mandatory!');
        }

        this.apiUrl = parseStringOr(process.env.REACT_APP_API_URL, "");

        if (this.apiUrl === "") {
            throw new Error('Api Url is riquired!');
        }

        this.apiKey = parseStringOr(process.env.REACT_APP_API_KEY, "");

        if (this.apiKey === "") {
            throw new Error('Api Key is riquired!');
        }

        this.tvConfigFile = parseStringOr(props.theme.tvConfigFile, "");

        if (this.tvConfigFile === "") {
            throw new Error('TV Config File is riquired!');
        }

        const urlLang = props.urlParams.get('lang') || "en";

        if (urlLang === "fr") {
            this.setLang(urlLang);
        }

        this.planApiCode = props.urlParams.get('planApiCode') || "";
        this.tvPlanId = props.urlParams.get('tvPlanId') || 0;
        this.token = props.urlParams.get('token') || "";
        this.webview = props.urlParams.get('webview') || "choose";
        this.urlReferrer = props.urlParams.get('urlReferrer') || "";

        if (this.tvPlanId === 0 ||
            this.token == "" ||
            this.org == "" ||
            this.urlReferrer == "") {
            this.token = null;
            this.tvPlanId = 0;
            this.urlReferrer = "";
        }

        this.config = props.theme.config;
        this.favExplicit = {};
        this.plan = null;
        this.starterMap = {};
        this.starterMapped = false;
        this.selection = {};
        this.nextsel = {};
        this.pickCount = 0;
        this.validPickCount = 0;
    }

    async componentDidMount() {
        switch (this.webview) {
            case 'admin':
            case 'subapp':
                if (!(this.tvPlanId) > 0) {
                    throw new Error('404 Not Found');
                }
                break;

            default:
                if (this.tvPlanId > 0) {
                    throw new Error('404 Not Found');
                }
                break;
        }

        const { t } = this.props;
        let plan = {
            apiCode: this.planApiCode,
            startPlan: "basic",
            des: "Standard TV",
            info: "",
            desFr: "Télévision Standard",
            infoFr: "",
            desType: t('Duo'),
            isNet: true,
            isTv: true,
            isVoice: false,
        };

        if (plan.apiCode !== "") {
            const response = await this.apiFetch('portal/plan/apicode', {apiCode: this.planApiCode});

            if (response != null && isObjectNotEmpty(response.data) && response.data.id > 0) {
                const splan = response.data;
                plan.startPlan = splan.tvConfigApiCode;
                plan.monthlyPrice = splan.monthlyPrice;
                plan.des = splan.label;
                plan.desFr = splan.labelFr;
                plan.info = splan.info;
                plan.infoFr = splan.infoFr;
                plan.isNet = (splan.isNet === 1);
                plan.isTv = (splan.isTv === 1);
                plan.isVoice = (splan.isVoice === 1);
            }
            else if (undefined !== defaultPlans[plan.apiCode]) {
                plan = {
                    ...plan,
                    ...defaultPlans[plan.apiCode]
                };
            }

            if (plan.isNet && plan.isTv && plan.isVoice) {
                plan.desType = t('trio');
            }
        }
        this.plan = plan;
        this.selection[plan.startPlan] = true;

        let updateAll = true;

        this.tvConfig = await this.apiUrlFetch(this.tvConfigFile);

        if (this.tvConfig == null || undefined === this.tvConfig.data) {
            throw new Error('Tv Config json file is required!');
        }

        if (undefined === this.tvConfig.data || undefined === this.tvConfig.data.plans) {
            throw new Error('Tv Config json structure is wrong!');
        }

        this.pickMode = parseStringOr(this.tvConfig.data?.pickMode, "FLEXIBLE").trim().toUpperCase();

        if (undefined === this.tvConfig.data.plans[this.plan.startPlan]) {
            throw new Error('Tv Plan does not exists!');
        }

        if (this.tvPlanId > 0) {
            let mdl = await this.apiFetch(`tvplan/${this.tvPlanId}`);

            if (mdl !== null && mdl.success) {
                this.tvPlan = mdl.data;
                let jdata = await parseJsonOr(mdl.data.jdata, null);

                if (jdata != null) {
                    this.plan = jdata.plan || {};

                    if (isStringEmpty(this.plan.startPlan)) {
                        this.plan.startPlan = parseStringOr(this.plan.tvConfigApiCode, "basic");
                    }

                    if (jdata.selData !== undefined) {
                        if (jdata.selData.selection !== undefined &&
                            jdata.selData.selection.pickGroup === undefined) {
                            jdata.selData.selection.pickGroup = {};
                        }

                        this.setState({...jdata.selData});
                        this.loadTvConfig();
                        this.nextsel = jdata.selData.selection;
                        this.setLang(jdata.selData.lang);
                        updateAll = false;
                    }
                }
            }
        }

        if (updateAll) {
            //warning , changing the satte will cause a lot
            // of re-renders down the line
            this.loadTvConfig();
            this.updateAll();
        }

        this.setState({loading: false});
    }

    resetSelection() {
        console.log("reset selection");
        let sel = {
            service: {},
            fav: {},
            pickGroup: {},
            implicit: {},
        };

        this.nextsel = sel;
        this.setState({selection:sel});
        this.updateAll();
    }

    indexStarter() {
        console.log("index starter");
        let cfg = this.getTvConfig();
        this.starterMapped = true;
        this.starterMap = {};

        if (undefined !== cfg.plans[this.plan.startPlan] &&
            Object.keys(cfg.plans[this.plan.startPlan]).length > 0) {
            for (let c of cfg.plans[this.plan.startPlan].services) {
                this.starterMap[c] = true;
            }
        }
    }

    loadTvConfig() {
        //depreciated..., replaced by import
        this.indexStarter();
    }

    getStarterPlan() {
        let cfg = this.getTvConfig();
        let p = { ...this.plan };
        p.data = cfg.plans[this.plan.startPlan];

        return p;
    }

    serviceIsInStarterPlan(code) {
        if (this.starterMapped != true) {
            this.indexStarter();
        }

        return (this.starterMap[code] == true);
    }

    getConfig(key) {
        const { i18n } = this.props;
        let lang = i18n.language || "en";

        if (undefined === this.config[lang]) {
            lang = "en";
        }

        if (undefined === key) {
            return this.config[lang] || {};
        }

        return this.config[lang][key] || {};
    }

    render() {
        if (this.state.loading) {
            return null;
        }

        const { t, i18n } = this.props;
        const value = {
            urlReferrer: this.urlReferrer,
            getOrg: this.getOrg.bind(this),
            getConfig: this.getConfig.bind(this),
            apiFetch: this.apiFetch.bind(this),
            getTvConfig: this.getTvConfig.bind(this),
            loadTvConfig: this.loadTvConfig.bind(this),
            getStarterPlan: this.getStarterPlan.bind(this),
            serviceIsInStarterPlan: this.serviceIsInStarterPlan.bind(this),
            startPlan: this.plan.startPlan,
            showServiceInfo: this.showServiceInfo.bind(this),
            hideServiceInfo: this.hideServiceInfo.bind(this),
            isServiceSelected: this.isServiceSelected.bind(this),
            isFavSelected: this.isFavSelected.bind(this),
            selectFavExplicit: this.selectFavExplicit.bind(this),
            unselectFavExplicit: this.unselectFavExplicit.bind(this),
            showRemoveFavDialog: this.showRemoveFavDialog.bind(this),
            isPickGoupSelected: this.isPickGoupSelected.bind(this),
            isServicePickGoupSelected: this.isServicePickGoupSelected.bind(this),
            selectPickGroup: this.selectPickGroup.bind(this),
            unselectPickGroup: this.unselectPickGroup.bind(this),
            resetPickGroup: this.resetPickGroup.bind(this),
            isServiceImplicit: this.isServiceImplicit.bind(this),
            selectServiceClick: this.selectServiceClick.bind(this),
            unselectServiceClick: this.unselectServiceClick.bind(this),
            parsePickGoupServices: this.parsePickGoupServices.bind(this),
            getPriceChoice: this.getPriceChoice.bind(this),
            getPlan: this.getPlan.bind(this),
            toggleHelp: this.toggleHelp.bind(this),
            getChecklist: this.getChecklist.bind(this),
            resetSelection: this.resetSelection.bind(this),
            getTotal: this.getTotal.bind(this),
            setLang: this.setLang.bind(this),
            getLang: this.getLang.bind(this),
            getSelData: this.getSelData.bind(this),
            getTvPlanId: this.getTvPlanId.bind(this),
            getWebview: this.getWebview.bind(this),
            getPickMode: this.getPickMode.bind(this),
            mustUpdate: this.state.mustUpdate,
        };

        let helpImg = (this.pickMode === 'FIXED') ? helpImgEnPickMode : helpImgEn;
        let planDes = this.plan.des;

        if (i18n.language === "fr") {
            helpImg = (this.pickMode === 'FIXED') ? helpImgFrPickMode : helpImgFr;
            planDes = this.plan.desFr;
        }

        return (
            <TvPlanContext.Provider value={value}>
                {this.config?.[i18n.language]?.showBackButton && (
                <div style={{marginBottom: 24, textAlign: 'left'}}>
                    <Button
                        type="link"
                        className="btn-link-go-back"
                        href={this.config[i18n.language]?.backButtonUrl}
                    >
                        <FontAwesomeIcon icon={faArrowLeft} style={{ marginRight: 8 }} />
                        {t('btn_go_back')}
                    </Button>
                </div>
                )}
                <TvPlanSteps stepAt={1}>
                    <TvPlanStep
                        index={1}
                        title={t('TvPlanStep1.title', {des: planDes})}
                        des={t('TvPlanStep1.des', {
                            type: this.plan.desType,
                            des: planDes,
                        })}
                    >
                        <TvPlanStarter />
                    </TvPlanStep>
                    <TvPlanStep
                        index={2}
                        title={t('TvPlanStep2.title')}
                        des={t('TvPlanStep2.des')}
                    >
                        <TvPlanFavList />
                    </TvPlanStep>
                    <TvPlanStep
                        index={3}
                        title={t('TvPlanStepNew3.title')}
                        des={t('TvPlanStepNew3.des')}
                    >
                        <TvPickMoviePack />
                    </TvPlanStep>
                    {this.pickMode === 'FIXED' && (
                    <TvPlanStep
                        index={4}
                        title={t('TvPickStepPickGroupPack.title')}
                        des={t('TvPickStepPickGroupPack.des')}>
                        <TvPickGroupPack pickMode={this.pickMode} />
                    </TvPlanStep>
                    )}
                    <TvPlanStep
                        index={this.pickMode === 'FIXED' ? 5 : 4}
                        title={t(this.org === "ctal" ? 'TvPlanStep3.title_ctal' : 'TvPlanStep3.title' )}
                        des={t('TvPlanStep3.des')}>
                        {this.pickMode !== 'FIXED' && (
                        <Fragment>
                        <Tip>{t('TvPlanStep3.tip1')}</Tip>
                        <Tip>{t('TvPlanStep3.tip2')}</Tip>
                        <Tip>
                            {t('TvPlanStep3.tip3')}
                            <FontAwesomeIcon className='icon' icon={faQuestionCircle} />
                            {t('TvPlanStep3.tip4')}
                        </Tip>
                        </Fragment>
                        )}
                        <TvPickList pickMode={this.pickMode} />
                    </TvPlanStep>
                    <TvPlanStep
                        index={this.pickMode === 'FIXED' ? 6 : 5}
                        last={true}
                        title={t('TvPlanStep4.title')}
                        des={t(this.webview === "subapp" ? 'TvPlanStep4.des_confirm' : 'TvPlanStep4.des')}
                    />
                </TvPlanSteps>
                {this.props.children}
                <TvReview
                    showGroupTip={this.state.showGroupTip}
                    groupCount={this.state.groupCount}
                    pickMoreForDiscountCount={this.state.pickMoreForDiscountCount}
                />
                <TvPlanFooter />
                <TvServiceInfo
                    code={this.state.showInfoServiceCode}
                    title="Service Info"
                    visible={this.state.showInfoVisible}
                />
                <TvDrawer
                    visible={true}
                    showGroupTip={this.state.showGroupTip}
                    groupCount={this.state.groupCount}
                    pickMoreForDiscountCount={this.state.pickMoreForDiscountCount}
                    price={this.state.price}
                />
                <Drawer
                    width="370"
                    open={this.state.showHelp}
                    onClose={() => this.toggleHelp()}
                    className="tv-help-drawer"
                    title={t("Help")}
                >
                    <img src={helpImg} alt="help" width="300" />
                </Drawer>
            </TvPlanContext.Provider>
        );
    }

    getPickMode() {
        return this.pickMode;
    }

    setLang(code) {
        const { i18n } = this.props;
        console.log("setlang:" + code);
        i18n.changeLanguage(code);
        this.setState({lang: code});
        this.updateAll();
    }

    getLang() {
        return this.state.lang;
    }

    getTotal() {
        return this.state.price;
    }

    getTvConfig() {
        return this.tvConfig.data || {};
    }

    getTvPlanId() {
        return this.tvPlanId;
    }

    getWebview() {
        return this.webview;
    }

    getUrlReferrer() {
        return this.urlReferrer;
    }

    toggleHelp() {
        this.setState({showHelp: !this.state.showHelp});
    }

    hideServiceInfo() {
       this.setState({showInfoVisible: false});
    }

    showRemoveFavDialog(code) {
        const { t, i18n } = this.props;
        let cfg = this.getTvConfig();
        let sel = this.nextsel || this.state.selection || {};
        let whichFavCode = "";
        let favDes = "";

        for (let fcode in sel.fav) {
            if (sel.fav[fcode]) {
                let favo = cfg.favs[fcode] || {};
                let favsv = favo.services || [];

                for (let ccode of favsv) {
                    if (ccode === code) {
                        whichFavCode = fcode;
                        favDes = parseStringOr(favo.des, fcode);

                        if (i18n.language === "fr" && parseStringOr(favo.desFr, "") !== "") {
                            favDes = favo.desFr;
                        }

                        break;
                    }
                }

                if (whichFavCode.length > 0) {
                    break;
                }
            }
        }
        //step 2, ask to remove
        if (whichFavCode.length < 1) {
            console.error("found as implicit, but didnt find in fav, code=" + code);
            return;
        }

        Modal.confirm({
            title: t("fav_remove_modal_title"),
            icon: <ExclamationCircleOutlined />,
            content: (<TvFavPackRemoveDialog>{favDes}</TvFavPackRemoveDialog>),
            okText: t('fav_remove_button'),
            okButtonProps: { type: 'primary' },
            cancelText: t('Cancel'),
            onOk: () => {
                console.log("remove-fav:" + whichFavCode);
                return this.unselectFav(whichFavCode);
            }
        });
        console.log("ask-to-remove-fav:" + whichFavCode);
    }

    showServiceInfo(scode) {
       this.setState({
            showInfoVisible:true,
            showInfoServiceCode:scode
        });
    }

    selectServiceClick(code) {
        if (this.isServiceImplicit(code)) {
            return;
        }

        let sel = this.state.selection;
        sel.service[code] = true;
        let cfg = this.getTvConfig();
        let sconfig = cfg.service[code] || {};
        let removeServices = sconfig.removePickServices || [];

        for (let sc of removeServices) {
            console.log("auto-remove" + sc);

            if (this.isServiceSelected(sc) == true) {
                sel.service[sc] = false;
                console.log("auto-service-unsel:" + sc);
            }

            if (this.isFavSelected(sc) == true) {
                sel.fav[sc] = false;
                console.log("auto-fav-unsel:" + sc);
            }
        }

        console.log("service-sel:" + code);
        this.nextsel = sel;
        this.setState({selection: sel});
        this.updateAll();
    }

    unselectServiceClick(code) {
        let sel = this.state.selection;
        sel.service[code] = false;
        console.log("service-unsel:" + code);
        this.nextsel = sel;
        this.setState({selection:sel});
        this.updateAll();
    }

    isServiceImplicit(code) {
        return parseBoolOr(this.state.selection?.implicit?.[code], false);
    }

    isServiceSelected(code) {
        return parseBoolOr(this.state.selection?.service?.[code], false);
    }

    isFavSelected(code) {
        return parseBoolOr(this.state.selection?.fav?.[code], false);
    }

    isPickGoupSelected(groupCode) {
        const { pickGroup } = this.state.selection;

        if (pickGroup[groupCode] !== undefined && Object.keys(pickGroup[groupCode]).length > 0) {
            for (let scode in pickGroup[groupCode]) {
                if (pickGroup[groupCode][scode]) {
                    return true;
                }
            }
        }

        return false;
    }

    isServicePickGoupSelected(code, groupCode) {
        const { pickGroup } = this.state.selection;

        if (pickGroup[groupCode] !== undefined &&
            Object.keys(pickGroup[groupCode]).length > 0 &&
            pickGroup[groupCode][code]) {
            return true;
        }

        return false;
    }

    getImplicitStarterPlansAndFavs() {
        const cfg = this.getTvConfig();
        const { selection } = this.state;
        let imp = {};

        for (let code in selection.fav) {
            if (selection.fav[code]) {
                let sconfig = cfg.favs[code] || {};

                for (let ccode of sconfig.services) {
                    imp[ccode] = true;
                }
            }
        }


        let startPlan = this.plan.startPlan;
        let pconfig = cfg.plans[startPlan] || {};

        for (let ccode of pconfig.services) {
            imp[ccode] = true;
        }

        return imp;
    }
    /**
     * Remove services part of StarPlan Or Favs
     */
    parsePickGoupServices(group) {
        let services = [];

        if (Array.isArray(group?.pickFromService) && group.pickFromService.length > 0) {
            // get services from startplan and favs
            const perseve = this.getImplicitStarterPlansAndFavs();
            group.price = parseFloat(group.price) || 0;
            group.pickCount = parseInt(group.pickCount) || 0;

            if (group.price > 0 && group.pickCount > 0) {
                for (let code of group.pickFromService) {
                    if (!(perseve[code] === true)) {
                        services.push(code);
                    }
                }
            }
        }

        return services;
    }

    selectPickGroup(code, group) {
        console.log("unselect-pick-group", group.code, code);
        let sel = this.state.selection;

        if (sel.pickGroup[group.code] === undefined) {
            sel.pickGroup[group.code] = {};
        }

        let selected = [];

        for (let scode in sel.pickGroup[group.code]) {
            if (sel.pickGroup[group.code][scode]) {
                selected.push(scode);
            }
        }
        // if already package is full
        if (selected.length === group.pickCount) {
            return selected;
        }

        selected.push(code);
        sel.pickGroup[group.code][code] = true;
        sel.service[code] = true;
        sel.implicit = this.getImplicit(sel);
        this.nextsel = sel;
        this.setState({selection: sel});
        this.updateGroupTip();
        this.updatePrice();

        return selected;
    }

    unselectPickGroup(code, group) {
        console.log("unselect-pick-group", group.code, code);
        let sel = this.state.selection;

        if (sel.pickGroup[group.code] === undefined ||
            sel.pickGroup[group.code][code] === undefined ||
            !sel.pickGroup[group.code][code]) {
            return [];
        }
        else {
            sel.pickGroup[group.code][code] = false;
            sel.service[code] = false;
        }

        let selected = [];

        for (let scode in sel.pickGroup[group.code]) {
            if (sel.pickGroup[group.code][scode]) {
                sel.service[scode] = true;
                selected.push(scode);
            }
        }

        sel.implicit = this.getImplicit(sel);
        this.nextsel = sel;
        this.setState({selection: sel});
        this.updateGroupTip();
        this.updatePrice();

        return selected;
    }

    resetPickGroup() {
        console.log("reset-pick-group");
        let sel = this.state.selection;

        for (let gcode in sel.pickGroup) {
            for (let code in sel.pickGroup[gcode]) {
                sel.pickGroup[gcode][code] = false;
                sel.service[code] = false;
            }
        }

        sel.implicit = this.getImplicit(sel);
        this.nextsel = sel;
        this.setState({selection: sel});
        this.updateGroupTip();
        this.updatePrice();
    }

    selectFavExplicit(code) {
        console.log("select-fav-explicit: " + code);
        let cfg = this.getTvConfig();
        let sconfig = cfg.favs[code] || {};
        this.selectFav(code,{explicit:true});
        //mark as explicit
        for (let ccode of sconfig.services) {
            this.selectExplicitFromFav(ccode);
        }
    }

    unselectFavExplicit(code) {
        console.log("un-select-fav-explicit: " + code);
        let cfg = this.getTvConfig();
        let sconfig = cfg.favs[code] || {};

        for (let ccode of sconfig.services) {
            this.unselectExplicitFromFav(ccode);
        }

        this.unselectFav(code);
    }

    selectFav(code,opts={}) {
        console.log("select-fav: " + code);
        let sel = this.state.selection;
        sel.fav[code] = true;
        let isExplicit = opts.explicit || false;
        console.log("is-explicit:" + isExplicit);

        let cfg = this.getTvConfig();
        let favc = cfg.favs[code] || {};
        let removeFavs = favc.removeFav || [];


        let thisFavMap = this.getFavMMap(code);
        //unselect fav auto
        for (let rc of removeFavs) {
            if (sel.fav[rc] == true) {


                sel.fav[rc] = false;
                if (isExplicit == true) {
                    let sconfig = cfg.favs[rc] || {};
                    for (let ccode of sconfig.services) {
                        this.favExplicit[ccode] = false;
                    }
                } else {
                    //auto upgrade
                    console.log("auto-unselect (implicit) :" + rc);
                    let sconfig = cfg.favs[rc] || {};
                    for (let ccode of sconfig.services) {
                        if (this.favExplicit[ccode] == true) {
                            if (thisFavMap[ccode] == true) { continue;}
                            console.log("!!!!  " + ccode + " should have been clicked as it was explicit in a fav");
                            sel.service[ccode] = true;
                        }
                    }
                }
            }
        }

        sel.implicit = this.getImplicit(sel);
        this.nextsel = sel;
        this.setState({selection:sel, mustUpdate: this.state.mustUpdate + 1});
        //dont autoselect fav
        this.updateGroupTip();
        this.updatePrice();
    }

    unselectFav(code) {
        let sel = this.state.selection;
        sel.fav[code] = false;
        sel.implicit = this.getImplicit(sel);
        //reselect favexplicits as individual
        this.nextsel = sel;
        this.setState({selection:sel, mustUpdate: this.state.mustUpdate + 1});
        //dont update autoselectfavs()
        this.updateGroupTip();
        this.updatePrice();
    }

    selectExplicitFromFav(code) {
         this.favExplicit[code] = true;
    }

    unselectExplicitFromFav(code) {
         this.favExplicit[code] = false;
    }

    getImplicit(sel) {
        const cfg = this.getTvConfig();
        let imp = {};

        for (let code in sel.pickGroup) {
            for (let ccode in sel.pickGroup[code]) {
                if (sel.pickGroup[code][ccode]) {
                    imp[ccode] = true;
                }
            }
        }

        for (let code in sel.fav) {
            if (sel.fav[code]) {
                let sconfig = cfg.favs[code] || {};

                for (let ccode of sconfig.services) {
                    imp[ccode] = true;
                }
            }
        }

        let startPlan = this.plan.startPlan;
        let pconfig = cfg.plans[startPlan] || {};

        for (let ccode of pconfig.services) {
            imp[ccode] = true;
        }

        return imp;
    }

    getFavMMap(code) {
        let imp = {};
        let cfg = this.getTvConfig();
        let sconfig = cfg.favs[code] || {};

        for (let ccode of sconfig.services) {
            imp[ccode] = true;
        }

        return imp;
    }

    updateAll() {
        this.updateGroupTip();
        this.updatePrice();
        this.autoSelectFavs();
    }

    updateGroupTip() {
        if (this.pickMode === 'FIXED') {
            return;
        }

        let cfg = this.getTvConfig();
        let sel = this.nextsel || this.state.selection || {};
        let maxGroupCount = 0;
        let groupCounts = [];
        let pickCount = 0;
        let validPickCount = 0;

        for (let code in sel.service) {
            if (sel.service[code]) {
                if (this.isServiceImplicit(code)) {
                    continue;
                }

                let sconfig = cfg.service[code] || {};

                if (sconfig.doesNotCountAsPick) {
                    continue;
                }

                pickCount++;

                let r = sconfig.rights || {};
                let minPickServices = r.minPickServices || 1;

                if (minPickServices > 0) {
                    groupCounts[minPickServices] = true;

                    if (minPickServices >= maxGroupCount) {
                        maxGroupCount = minPickServices;
                    }
                }
            }
        }

        for (let code in sel.service) {
            if (sel.service[code]) {
                if (this.isServiceImplicit(code)) {
                    continue;
                }

                let sconfig = cfg.service[code] || {};

                if (sconfig.doesNotCountAsPick) {
                    continue;
                }

                let r = sconfig.rights || {};
                let minPickServices = r.minPickServices || 1;

                if (pickCount >= minPickServices) {
                    validPickCount++;
                }
            }
        }

        let diff = this.state.pickMoreForDiscountCount;
        let showGroupTip = false;

        if (pickCount > 0 && pickCount < maxGroupCount) {
            showGroupTip = true;

            for (let i in groupCounts) {
                if (i <= pickCount) {
                    continue;
                }

                diff = i - pickCount;

                if (diff < 1) {
                    continue;
                }

                console.log("test "  + pickCount + "/" + i + " (missing:"+diff+") for discoutn");
            }
        }

        this.pickCount = pickCount;
        this.validPickCount = validPickCount;
        this.setState({
            pickCount: pickCount,
            groupCount: maxGroupCount,
            pickMoreForDiscountCount: diff,
            showGroupTip: showGroupTip,
        });
    }

    getPlan() {
        return this.plan;
    }

    getPriceChoice(code) {
        return this.state.priceChoice?.[code] || false;
    }

    getChecklist() {
        return this.state.checklist || [];
    }

    autoSelectFavs() {
        if (this.pickMode === 'FIXED') {
            return;
        }

        const { t, i18n } = this.props;
        console.log("fav-autoselect-test");
        let cfg= this.getTvConfig();
        let sel = this.nextsel || this.state.selection || {};

        let r1  = this.calcPriceScenario(sel);
        let atPrice = r1.price || 0;
        if (atPrice < 0.01) { return;}

        let startCode = this.plan.startPlan;
        let starto =  cfg.plans[startCode] || {};
        let myFavs = starto.favs || [];
        let mustClickFav = false;
        let mustClickFavCode = null;
        let bestDealNow = 9999999;
        //mark unallowed favs
        let blacklistFavs = {};

        for (let code in sel.fav) {
            if (sel.fav[code] == true) {
                let favc = cfg.favs[code] || {};
                let blFavs = favc.blacklistAutoSelectFav || [];
                for (let rc of blFavs) {
                    blacklistFavs[rc] =true;
                }
            }
        }

        for (let code of myFavs) {
            if (sel.fav[code] == true) { continue;} //fav is already selected
            if (blacklistFavs[code] == true) { continue;} //fav is blacklisted because in the list of remove from a already selected fav
            let favo = cfg.favs[code] || {};
            let favsv = favo.services || [];
            console.log("fav-autoselect-testing:" + code);

            //if the fav has no business with this click, ignore
            let favHasServiceSel = false;
            for (let ccode of favsv) {
                if (sel.service[ccode] == true) {
                    favHasServiceSel = true;
                    break;
                }
            }
            if (favHasServiceSel != true) {
                console.log("FAV:" + code + " has 0 services clicked!");
                continue;
            } //ignore if the fav as 0 servcices clicked

            //console.log("fav-autoselecttest:" + code,favsv);
            let trySel = {
                service:{...sel.service},
                fav:{...sel.fav},
                implicit:{...sel.implcit}
            }

            //fake select...
            trySel.fav[code] = true;

            //fake remove autoremove favs...
            let removeFavs = favo.removeFav || [];
            for (let rc of removeFavs) {
                trySel.fav[rc] =false;
                let rfavo = cfg.favs[rc] || {};
                let rfavsv = rfavo.services  || [];
                for (let rscode of rfavsv) {
                    trySel.implicit[rscode]= false;

                    if (this.favExplicit[rscode] == true) {
                        trySel.service[rscode] = true;//click straight
                        //console.log(`test:${code} , autoremove ${rc}, service:${rscode} was EXPLICIT`);
                    } else {
                        //console.log(`test:${code} , autoremove ${rc}, service:${rscode} was implicit`);
                    }
                }

            }


            for (let ccode of favsv) {
                trySel.service[ccode] = false;
                trySel.implicit[ccode] = true;
            }
            trySel.pickCount = 0;
            for (let ccode in trySel.service) {
                if (trySel.implicit[ccode]== true) { continue;}
                if (trySel.service[ccode] == true) {
                    trySel.pickCount ++;
                }
            }

            let r = this.calcPriceScenario(trySel);
            let rp = r.price || 0;
            console.log("fav-autoselect-testing:" + code + " return price=" +rp + " at-price=" + atPrice);
            //console.warn(r.checklist);
            //console.log(rp);
            if (rp > 0) {
                if (rp <= atPrice) {
                    //we have a deal!
                    if (rp <= bestDealNow) {
                        mustClickFav = true;
                        mustClickFavCode = code;
                        bestDealNow = rp;
                        //console.log(trySel);
                        console.log("fav-autoselect:"+ code + " new-price:" + rp + ", old-price=" + atPrice);
                    }
                }
            }
        }

        if (mustClickFav == true) {
            let favc = cfg.favs[mustClickFavCode];
            let favd = favc.des || mustClickFavCode;
            let desFr = favc.desFr || "";
            if (i18n.language == "fr" && desFr.length > 0) { favd=desFr;}

            let savings = atPrice - bestDealNow;
            console.log("found better deal with fav:" +mustClickFavCode + " saving :" + savings);
            notification.info({
                icon:(<FontAwesomeIcon style={{color:"green"}} icon={faBadgeCheck} />),
                message: t("Savings!"),
                  description:t("We automatically added the Favorite pack") + " " +  favd + " " + t("to bring you savings") + ".",
                  placement:"topLeft",
                  duration:3
            })
            return this.selectFav(mustClickFavCode);
        }
    }

    updatePrice() {
        let sel = this.nextsel || this.state.selection;
        sel.pickCount = this.pickCount;
        let r = this.calcPriceScenario(sel);
        //r.servicePrice
        //r.checklist=checklist;
        //r.hasPicks=hasPicks;
        //r.priceChoice=priceChoic;
        //r.price=total;
        this.setState(r);
    }

    calcPriceScenario(sel) {
        console.log("calc-sel-pick-count"  + sel.pickCount);
        const { t, i18n } = this.props;
        const cfg = this.getTvConfig();
        const channels =  cfg?.channels || {};
        let total = 0;
        let priceChoice = {};
        let checklist = [];
        let priceAt = {};
        let r = {};
        let planDes = this.plan?.des || "";

        if (i18n.language === "fr") {
            planDes = this.plan?.desFr || "";
        }

        checklist.push({
            key: 'startPlan',
            des: t('tvreview_start_with', {text: planDes}),
            price: 0,
        });

        let serviceIsFromFavMap = {};

        for (let code in sel.fav) {
            if (sel.fav[code] == true) {
                let sconfig = cfg.favs[code] || {};
                let des = sconfig.des;

                if (i18n.language === "fr") {
                    let desFr = sconfig.desFr || "";
                    if (desFr.length > 0) { des = desFr;}
                }

                let p = sconfig.price || 0;
                total += p;
                checklist.push({
                    key: 'theme',
                    des: t('tvreview_add_theme', {text: des}),
                    price: p,
                });

                for (let scode of sconfig.services) {
                    serviceIsFromFavMap[scode] = true;
                }
            }
        }

        let serviceIsFromPickGroup = {};

        for (let code in sel.pickGroup) {
            if (sel.pickGroup[code]) {
                let sconfig = cfg.fixedPicks[code]||{};
                let pgprice = 0;
                let pgerror = true;
                let pgerror_message = null;
                let pgdes_error = null;

                for (let scode in sel.pickGroup[code]) {
                    if (sel.pickGroup[code][scode]) {
                        serviceIsFromPickGroup[scode] = true;
                        priceChoice[scode] = "standalone";
                    }
                }

                let pgservices = Object.keys(serviceIsFromPickGroup);

                if (pgservices.length < 1) {
                    continue;
                }
                else if (pgservices.length === sconfig.pickCount) {
                    total += sconfig.price;
                    pgprice = sconfig.price;
                    pgerror = false;
                }
                else {
                    pgdes_error = t('tvreview_error_pickpack_des', {
                        unit: sconfig.pickCount,
                        price: sconfig.price,
                        missing: sconfig.pickCount - pgservices.length,
                    });
                    pgerror_message = t('tvreview_error_pickpack_title', {
                        unit: sconfig.pickCount,
                        price: sconfig.price,
                        missing: pgservices.length,
                    });
                }

                checklist.push({
                    key: 'pickpack',
                    des: t('tvreview_pick_pack', {
                        unit: sconfig.pickCount,
                        price: sconfig.price,
                    }),
                    des_error: pgdes_error,
                    price: pgprice,
                    services: pgservices,
                    error: pgerror,
                    error_message: pgerror_message,
                });
            }
        }

        let pickedServices = [];
        let saServices = [];
        let hasPicks = false;
        let pickTotal = 0;
        let pickCount = 0;
        r.servicePrice = {};

        for (let code in sel.service) {
            if (sel.service[code] == true) {
                if (sel.implicit[code]) { continue; }
                if (serviceIsFromFavMap[code]) { continue; }
                if (serviceIsFromPickGroup[code]) { continue; }
                const channel = channels[code] || null;
                const sconfig = cfg.service[code] || {};
                let priceo = sconfig.price || {};
                let p = priceo.standalone || 0;
                let ri = sconfig.rights || {};
                let minPickServices = ri.minPickServices || 1;
                let myPriceChoice = "standalone";
                r.servicePrice[code] = p;

                if (sel.pickCount >= minPickServices) {
                    let pickp = priceo.pick || 0;

                    if (pickp > 0) {
                         myPriceChoice = "pick";
                         p = pickp;
                         pickCount++;
                         hasPicks = true;
                         pickedServices.push(code);
                         pickTotal += p;
                         r.servicePrice[code] = p;
                    }
                }

                if (myPriceChoice === "standalone") {
                    saServices.push({
                        key: 'standalone',
                        des: t('tvreview_standalone', {text: parseStringOr(channel?.des, code)}),
                        price: p
                    });
                }

                if (myPriceChoice !== "pick") {
                    console.log(`pricechoice ${code} : ${sel.pickCount} / ${minPickServices} : ${myPriceChoice}`);
                }

                priceChoice[code] = myPriceChoice;
                priceAt[code] = p;
                total += p;
            }
        }

        if (hasPicks) {
            checklist.push({
                key: 'groupof',
                des: t('tvreview_groupof', {text: pickCount}),
                price: pickTotal,
                services: pickedServices,
                servicesDes: pickedServices.map(code => parseStringOr(channels[code]?.des, code)),
            });
        }

        for (let i of saServices) {
            checklist.push(i);
        }

        r.checklist = checklist;
        r.hasPicks = hasPicks;
        r.priceChoice = priceChoice;
        r.priceAt = priceAt;
        r.price = total;

        return r;
    }

    getSelData() {
        const { i18n } = this.props;
        let r = {};
        r.lang = i18n.language;
        r.checklist = this.state.checklist;
        r.hasPicks = this.state.hasPicks;
        r.price = this.state.price;
        r.priceChoice = this.state.priceChoice;
        r.priceAt = this.state.priceAt;
        r.selection = this.state.selection;

        return r;
    }

    getOrg() {
        return this.org;
    }

    async apiFetch(action, data) {
        let body = {
            org: this.org,
            app: this.app,
            data: data
        };

        if (this.token !== null) {
            body.sessiontoken = this.token;
        }
        else {
            body.apikey = this.apiKey;
        }

        try {
            let response = await fetch(this.apiUrl + action, {
                method: 'POST',
                crossDomain: true,
                body: JSON.stringify(body),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                }
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            return json;
        }
        catch (error) {
            notification['warning']({
               message: 'An error has occurred while establishing the connection to the server.',
               description: 'Please, try to reload the page, and if the error persists, contact the support team.',
               top: 80,
               duration: 5
            });
            console.log(error);
            return null;
        }
    }

    async apiUrlFetch(url, data, method) {
        if (undefined === method) {
            method = 'GET';
        }

        try {
            let response = await fetch(url, {
                method: method,
                crossDomain: true,
                body: JSON.stringify(data),
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Cache-Control': 'no-cache',
                }
            });

            if (response == null) {
                throw new Error('Error: Response is null');
            }

            let json = await response.json();

            if (json == null) {
                throw new Error('Error: Json is null');
            }

            return json;
        }
        catch (error) {
            notification['warning']({
               message: 'An error has occurred while establishing the connection to the server.',
               description: 'Please, try to reload the page, and if the error persists, contact the support team.',
               top: 80,
               duration: 5
            });
            console.log(error);
            return null;
        }
    }
}


const TvPlanContextProvider = withTranslation('tvplan')(TvPlanContextProviderCom);
//const TvPlanContextProvider = TvPlanContextProviderCom;

export {
    TvPlanContext,
    TvPlanContextProvider,
    TvPlanContextConsumer
}
